import * as React from 'react';
import { observer } from 'mobx-react';
import {
    closeOverlay,
    openOverlay,
    OverlayComponentProps,
    OverlayNote,
    OverlayNoteButton
} from '../../components/overlay';
import { injectTSDI } from '../../core/tsdi';
import { I18nStore } from '../../core/i18n-store';

export const UNDERAGE_POPUP_ID = 'underage-popup';

export const openUnderagePopup = () => {
    openOverlay({
        id: UNDERAGE_POPUP_ID,
        component: UnderagePopup
    });
};

export const closeUnderagePopup = () => {
    closeOverlay(UNDERAGE_POPUP_ID);
};

export const UnderagePopup = observer((props: OverlayComponentProps) => {
    const { translate } = injectTSDI(I18nStore);

    return (
        <OverlayNote>
            <b> {translate('customer.day.of.birth')}</b>
            <p>
                {' '}
                {translate('onlinepages.no.underage.warning', props.age ?? 18)}
            </p>
            <OverlayNoteButton onClick={props.closeOverlay}>
                {translate('onlinepages.ok.all.clear')}
            </OverlayNoteButton>
        </OverlayNote>
    );
});
